module.exports = __webpack_public_path__ + "static/media/levain_bg_img_4.4d349313.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slider/levain_bg_img_4.jpg
// module id = 1059
// module chunks = 0